
<div class="container-fluid mt-3">
    <div class="row">
        <div class="col common-list-wrapper">
            <ul class="nav nav-pills flex-column">
                <li class="nav-item">
                    <a routerLinkActive="active" routerLink="webapps" class="nav-link">
                        <img src="../../../../assets/App-Services.svg" class="icon-17 me-1">
                        <span>App Services</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a routerLinkActive="active" routerLink="functions" class="nav-link">
                        <img src="../../../../assets/Function-Apps.svg" class="icon-17 me-1">
                        <span>Azure Functions</span>
                    </a>
                </li>              
            </ul>
        </div>        
        <div class="col">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>





